"use client"

// src/switch.tsx
import { useCheckbox } from "@yamada-ui/checkbox";
import {
  forwardRef,
  omitThemeProps,
  ui,
  useComponentMultiStyle
} from "@yamada-ui/core";
import { motion } from "@yamada-ui/motion";
import { cx, dataAttr } from "@yamada-ui/utils";
import { cloneElement } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var Switch = forwardRef((props, ref) => {
  const [styles, mergedProps] = useComponentMultiStyle("Switch", props);
  const {
    className,
    children,
    flexDirection,
    gap = "0.5rem",
    icon,
    isReverse,
    reverse = isReverse,
    transition = {
      type: "spring",
      damping: 40,
      stiffness: 700
    },
    inputProps,
    labelProps,
    ...computedProps
  } = omitThemeProps(mergedProps);
  const {
    active,
    checked,
    focused,
    hovered,
    props: rest,
    getContainerProps,
    getIconProps,
    getInputProps,
    getLabelProps
  } = useCheckbox({ selectOnEnter: true, ...computedProps });
  const cloneIcon = icon ? cloneElement(icon, {
    active,
    checked,
    focused,
    hovered,
    isActive: active,
    isChecked: checked,
    isFocused: focused,
    isHovered: hovered
  }) : null;
  return /* @__PURE__ */ jsxs(
    ui.label,
    {
      ref,
      className: cx("ui-switch", className),
      __css: {
        alignItems: "center",
        cursor: "pointer",
        display: "inline-flex",
        flexDirection: flexDirection != null ? flexDirection : reverse ? "row-reverse" : "row",
        gap,
        position: "relative",
        verticalAlign: "top",
        ...styles.container
      },
      ...getContainerProps(),
      ...rest,
      children: [
        /* @__PURE__ */ jsx(
          ui.input,
          {
            className: cx("ui-switch__input", className),
            "aria-checked": checked,
            role: "switch",
            ...getInputProps(inputProps, ref)
          }
        ),
        cloneIcon != null ? cloneIcon : /* @__PURE__ */ jsx(motion.div, { layout: true, layoutRoot: true, children: /* @__PURE__ */ jsx(
          ui.div,
          {
            className: cx("ui-switch__track", className),
            __css: {
              alignItems: "center",
              boxSizing: "content-box",
              display: "inline-flex",
              flexShrink: 0,
              justifyContent: "flex-start",
              ...styles.track
            },
            ...getIconProps(),
            children: /* @__PURE__ */ jsx(
              motion.div,
              {
                className: cx("ui-switch__thumb", className),
                "data-checked": dataAttr(checked),
                layout: true,
                transition,
                __css: { ...styles.thumb }
              }
            )
          }
        ) }),
        children ? /* @__PURE__ */ jsx(
          ui.span,
          {
            className: cx("ui-switch__label", className),
            __css: { ...styles.label },
            ...getLabelProps(labelProps),
            children
          }
        ) : null
      ]
    }
  );
});
Switch.displayName = "Switch";
Switch.__ui__ = "Switch";

export {
  Switch
};
//# sourceMappingURL=chunk-HSYJX3NZ.mjs.map